/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol extends models.ServiceAccountCredentialsBaseForJiraServiceManagement {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol>): ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol(), model);
        ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol>): ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol.newInstance(<ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForJiraServiceManagement.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForJiraServiceManagementBasicAuthProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Username. This is a required field.
     */
    username: string;

    /**
     * API Token. This is a required field.
     */
    api_token: string;

    /**
     * Domain. This is a required field.
     */
    domain: string;

}
